export default __webpack_public_path__ + "static/media/ceritificate-background.9fe42405.png";